import React, { useContext } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

import { OnlineStoreContext } from '.'

const useStyles = makeStyles({
  logo: {
    margin: 16,
    height: 60,
    maxWidth: '100%'
  }
})

export function Logo() {
  const classes = useStyles()
  const { config } = useContext(OnlineStoreContext)

  return (
    <Box display="flex" alignItems="center" justifyContent="center" bgcolor="#FFF" width="100%">
      <img src={config?.imageUrl} alt={config?.brandName} className={classes.logo} loading="lazy" />
    </Box>
  )
}
